<p-drawer
  [visible]="display"
  position="right"
  appendTo="body"
  (onHide)="onHide()">
  <div class="mb-2 left-sidebar clientdetails">
    <h2 class="mb-4">Updates</h2>
    <div #updatesContainer class="mb-auto scrol-bx">
      <div *ngFor="let updates of workflowUpdatesList">
        <div class="update-txt border-bottom pt-2 pb-2">
          <div class="fonts-12">
            <label class="font-weight-light">{{
              updates.createdDate | date: "HH:mm:ss MMMM dd,yyyy"
            }}</label>
          </div>
          <div class="mt-2 mb-2">
            <label style="font-size: small">{{ updates.message }}</label>
          </div>
          <div class="text-right fonts-12" style="text-align: right">
            <label class="font-weight-light">By {{ updates.createdBy }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <textarea
        cols="30"
        rows="10"
        style="height: 90px; width: 100%"
        placeholder="Post updates here"
        [(ngModel)]="update"></textarea>
    </div>
    <div style="text-align: right">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="postWorkflowUpdate()">
        Post
      </button>
    </div>
  </div>
</p-drawer>
